import { render } from "./Footer.vue?vue&type=template&id=a25b657e"
const script = {}

import exportComponent from "/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__